module.exports = __webpack_public_path__ + "static/media/sky-blue-add-driver.4860ca7b.svg";